import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

/* Fetch with HttpOnly-cookie session + automatic one-shot refresh on 401. */
import { demoFixture, demoDynamic } from '../demo/demoMode';

export async function authFetch(path, options = {}) {
  try {
    if (sessionStorage.getItem('kx_demo') === '1') {
      const method = (options.method || 'GET').toUpperCase();
      const dyn = demoDynamic(path, method);
      if (dyn) {
        return new Response(JSON.stringify(dyn), { status: 200, headers: { 'Content-Type': 'application/json' } });
      }
      if (method !== 'GET') {
        return new Response(JSON.stringify({ ok: true, demo: true }), { status: 200, headers: { 'Content-Type': 'application/json' } });
      }
      const fx = demoFixture(path);
      if (fx) {
        return new Response(JSON.stringify(fx), { status: 200, headers: { 'Content-Type': 'application/json' } });
      }
      return new Response(JSON.stringify({}), { status: 404, headers: { 'Content-Type': 'application/json' } });
    }
  } catch { /* no sessionStorage */ }
  const isForm = options.body instanceof FormData;
  const doFetch = () =>
    fetch(`${API}/api${path}`, {
      credentials: 'include',
      ...options,
      headers: { ...(isForm ? {} : { 'Content-Type': 'application/json' }), ...(options.headers || {}) },
    });
  let res = await doFetch();
  if (res.status === 401 && !path.startsWith('/auth/')) {
    const r = await fetch(`${API}/api/auth/refresh`, { method: 'POST', credentials: 'include' });
    if (r.ok) res = await doFetch();
  }
  return res;
}

export async function fetchMe() {
  // Hard 8s budget: a slow/blocked backend must never leave guards on "Verificando acceso…" forever.
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), 8000);
  try {
    const r = await authFetch('/auth/me', { signal: ctrl.signal });
    if (r.ok) return await r.json();
    if (r.status === 401) {
      const rf = await fetch(`${API}/api/auth/refresh`, { method: 'POST', credentials: 'include', signal: ctrl.signal });
      if (rf.ok) {
        const r2 = await authFetch('/auth/me', { signal: ctrl.signal });
        if (r2.ok) return await r2.json();
      }
    }
    return null;
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}

export async function logoutSession() {
  try {
    await fetch(`${API}/api/auth/logout`, { method: 'POST', credentials: 'include' });
  } catch { /* ignore */ }
}

let mePromise = null;
const listeners = new Set();

export function clearAuthCache() {
  mePromise = fetchMe();
  mePromise.then((u) => listeners.forEach((fn) => fn(u)));
}

/* undefined = checking · null = guest · object = authenticated admin */
export function useAuthUser() {
  const [user, setUser] = useState(undefined);
  useEffect(() => {
    if (!mePromise) mePromise = fetchMe();
    let on = true;
    const fn = (u) => { if (on) setUser(u); };
    listeners.add(fn);
    mePromise.then(fn);
    return () => { on = false; listeners.delete(fn); };
  }, []);
  return user;
}
